import {
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_VIGENTE,
  CONTRATO_STATUS_ENCERRADO,
} from '../../../library/ContratoStatus';

export const PUFVAssessorPedagogicoGestorPermissions = {
  id: 'pufv_assessor_pedagogico_gestor',

  navbar: {
    view: true,
    profile: {
      edit: true,
      perfilBeta: false,
    },
  },

  projetos: {
    list: true,
    register: true,
    edit: true,
    approve: true,
    reprove: true,
    editFinished: false,
    remove: false,
    viewChecker: {
      professorGestor: false,
      coordenadorLocal: false,
    },
    filters: {
      situacao: true,
      coop: true,
    },
  },

  reembolsos: {
    list: true,
    register: true,
    edit: true,
    remove: true,
  },

  professores: {
    list: true,
    register: true,
    edit: true,
    approve: true,
    reprove: true,
    activate: true,
    deactivate: true,
    canRemove: false,
  },

  assessores: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  coordenadores: {
    list: true,
    register: true,
    edit: true,
    activate: true,
    deactivate: true,
    canRemove: false,
  },

  empresas: {
    list: false,
    register: false,
    edit: false,
    remove: false,
  },

  escolas: {
    list: true,
    register: true,
    edit: true,
    activate: true,
    deactivate: true,
    dadosDaEscola: {
      list: true,
      register: true,
      edit: true,
      duplicate: true,
      remove: true,
    },
    ideb: {
      list: true,
      register: true,
      edit: true,
      remove: true,
    },
  },

  relatorios: {
    generate: {
      projetos: true,
      'dados-cadastrais': true,
      'dados-gerais': true,
      'dados-do-programa': true,
      assessoria: true,
      'dados-do-ideb': false,
      contratos: false,
      escolas: true,
    },
  },

  agendaAssessoresPedagogicos: {
    list: true,
    register: true,
    edit: {
      locked: false,
      unlocked: true,
    },
    lock: true,
    unlock: true,
    remove: [true, true, true, true, true],
  },

  materiaisPedagogicos: {
    list: true,
    download: true,
  },

  dashboard: {
    generate: true,
  },

  contratos: {
    list: true,
    editEvenWhenDisabled: false,
    assessor: {
      allStatus: [
        CONTRATO_STATUS_NAO_INICIADO,
        CONTRATO_STATUS_VIGENTE,
        CONTRATO_STATUS_ENCERRADO,
      ],
      edit: false,
      register: false,
      view: true,
      upload: false,
      changeUpload: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
      templates: {
        list: false,
        edit: false,
      },
    },
    entePublico: {
      allStatus: [],
      downloadChecklist: false,
      edit: false,
      register: false,
      view: false,
      uploadNaoAssinado: false,
      uploadAssinado: false,
      uploadExtrato: false,
      changeUploadAssinado: false,
      changeUploadExtrato: false,
      changeUploadPlanoTrabalho: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
    },
    entePrivado: {
      allStatus: [],
      edit: false,
      register: false,
      view: false,
      upload: false,
      changeUpload: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
      templates: {
        list: false,
        edit: false,
      },
    },
  },
};
